import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CoBorrowerState {
  borrowerId: string | null;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  email: string;
  phone: string;
  personalIdNumber: string;
  isLocked: boolean;
  confirmEmail?: string;
  eligible: boolean;
  requiredInformationComplete?: boolean;
}
const initialState: CoBorrowerState = {
  borrowerId: null,
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  email: '',
  confirmEmail: '',
  phone: '',
  personalIdNumber: '',
  isLocked: false,
  eligible: false,
  requiredInformationComplete: false,
};

const coBorrower = createSlice({
  name: 'borrower',
  initialState,
  reducers: {
    setCoBorrower: (state: CoBorrowerState, { payload }: PayloadAction<Partial<CoBorrowerState>>) => {
      Object.assign(state, payload);
    },
    clearCoBorrower: () => initialState,
  },
});

export const { setCoBorrower, clearCoBorrower } = coBorrower.actions;

export default coBorrower.reducer;
